import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";
import { Field, Input, Textarea, SaveBar } from "./adminUi";
import { Plus, Trash2 } from "lucide-react";

export default function AdminAbout() {
  const [content, setContent] = useState(null);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    api.get("/content").then((r) => setContent(r.data)).catch(() => {});
  }, []);

  const update = (k, v) => setContent((c) => ({ ...c, about: { ...c.about, [k]: v } }));
  const updateStat = (i, k, v) => {
    const stats = [...(content.about.stats || [])];
    stats[i] = { ...stats[i], [k]: v };
    update("stats", stats);
  };
  const addStat = () => update("stats", [...(content.about.stats || []), { label: "New metric", value: "0" }]);
  const removeStat = (i) => update("stats", content.about.stats.filter((_, idx) => idx !== i));

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/admin/content", content);
      toast.success("About page updated");
    } catch {
      toast.error("Failed to save");
    } finally {
      setSaving(false);
    }
  };

  if (!content) return <div className="text-white/60">Loading…</div>;
  const a = content.about;

  return (
    <div data-testid="admin-about">
      <p className="text-xs uppercase tracking-[0.25em] text-fuchsia-400">About page</p>
      <h1 className="mt-2 text-3xl font-bold tracking-tight text-white md:text-4xl">About content</h1>

      <div className="mt-10 grid gap-6 rounded-2xl border border-white/10 bg-[#131B2F] p-8">
        <Field label="Title"><Input value={a.title} onChange={(e) => update("title", e.target.value)} data-testid="about-title-input" /></Field>
        <Field label="Lead paragraph"><Textarea rows={3} value={a.lead} onChange={(e) => update("lead", e.target.value)} data-testid="about-lead-input" /></Field>
        <Field label="Body (story)"><Textarea rows={6} value={a.body} onChange={(e) => update("body", e.target.value)} data-testid="about-body-input" /></Field>
        <div className="grid gap-6 md:grid-cols-2">
          <Field label="Mission"><Textarea rows={3} value={a.mission} onChange={(e) => update("mission", e.target.value)} data-testid="about-mission-input" /></Field>
          <Field label="Vision"><Textarea rows={3} value={a.vision} onChange={(e) => update("vision", e.target.value)} data-testid="about-vision-input" /></Field>
        </div>
      </div>

      <div className="mt-8 rounded-2xl border border-white/10 bg-[#131B2F] p-8">
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-semibold text-white">Stats</h3>
          <button onClick={addStat} data-testid="about-add-stat" className="inline-flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-1.5 text-xs hover:border-white/30">
            <Plus size={12} /> Add stat
          </button>
        </div>
        <div className="mt-6 grid gap-4 md:grid-cols-2">
          {(a.stats || []).map((s, i) => (
            <div key={i} className="grid grid-cols-[1fr_1fr_auto] items-end gap-3">
              <Field label="Value"><Input value={s.value} onChange={(e) => updateStat(i, "value", e.target.value)} /></Field>
              <Field label="Label"><Input value={s.label} onChange={(e) => updateStat(i, "label", e.target.value)} /></Field>
              <button onClick={() => removeStat(i)} className="mb-0.5 rounded-lg border border-white/10 p-2.5 text-white/60 hover:text-white" data-testid={`about-remove-stat-${i}`}>
                <Trash2 size={14} />
              </button>
            </div>
          ))}
        </div>
      </div>

      <SaveBar onSave={save} saving={saving} />
    </div>
  );
}
